import { Outlet } from 'react-router-dom';
import { AdminMenu } from './components/AdminMenu';
import { useAdminPanelAccess } from './useAdminPanelAccess';

export const AdminLayout = () => {
  const adminMenuList = useAdminPanelAccess();

  return (
    <div className="w-full h-full flex bg-base-70">
      <AdminMenu menu={adminMenuList} />
      <div className="grow overflow-auto py-8 px-10">
        <Outlet />
      </div>
    </div>
  );
};
